export default class Live {
    constructor(api) {
        this._api = api;
    }

    lives() {
        return this._api.get(`/admin/lives`).then(r => r.data.lives);
    }
}